/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { BCode } from "@src/app/model/bcode";
import { BCodePageComponent } from "@src/app/modules/budget/b-code-page/b-code-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const BCodePageNavRoute = new NavRoute('budgets/bcodes', ()=>BCodePageComponent, 'code').setViews(() => {
    return [
        {
            id: 'allBCode',
            name: 'All Budget Codes',
            helpText: 'All budget codes regardless of type',
            filterFields: {
                typeId: 'All',
                name: null,
                sort: null,
            }
        },
        {
            id: 'expenses',
            name: 'Expenses',
            helpText: 'Expense budget codes only',
            filterFields: {
                typeId: BCode.TYPE.EXPENSE.id,
                name: null,
                sort: null,
            }
        },
        {
            id: 'income',
            name: 'Income',
            helpText: 'Income budget codes only',
            filterFields: {
                typeId: BCode.TYPE.INCOME.id,
                name: null,
                sort: null,
            }
        },
        {
            id: 'assets',
            name: 'Assets',
            helpText: 'Asset accounts only',
            filterFields: {
                typeId: BCode.TYPE.ASSET.id,
                name: null,
                sort: null,
            }
        },
        {
            id: 'liabilities',
            name: 'Liabilities',
            helpText: 'Liability accounts only',
            filterFields: {
                typeId: BCode.TYPE.LIABILITY.id,
                name: null,
                sort: null,
            }
        },
        {
            id: 'capital',
            name: 'Capital',
            helpText: 'Capital accounts only',
            filterFields: {
                typeId: BCode.TYPE.CAPITAL.id,
                name: null,
                sort: null,
            }
        }
    ];
});
